//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscBundle(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21 9H22V3H2V9H19V18.9961H5V11H3V20.9961H21V9ZM4.22222 5V7H19.7778V5H4.22222Z" fill="currentColor" /><path d="M9.5 14.5814L12.5133 10.498V13.4147H14.5L11.4867 17.498V14.5814H9.5Z" fill="currentColor" /></svg>;
}
export default IconMiscBundle;